<template>
  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
    <template v-if="editableMode">
      <td class="text-center align-middle border-t border-r px-2" />
      <td class="border-t">
        {{ stockoutdetail.item.name }}
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 py-4">
          {{ selectedItemUnit }}
        </div>
      </td>
      <td class="border-t">
        <div class="text-right">
          <number-input
            v-model="detail.qty_out"
            class=""
            :error="errors.qty_out" />
        </div>
      </td>
      <td class="border-t">
        <div class="py-2">
          <text-input
            v-model="detail.desc"
            class=""
            :error="errors.desc"
            rows="1" />
        </div>
      </td>
      <td class="py-2 border-t">
        <div class="flex items-center px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Edit" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
    <template v-else>
      <td class="text-center align-middle border-t border-r px-2">
        {{ rowNumber }}.
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ stockoutdetail.item.name }}
        </div>
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 py-4">
          {{ selectedItemUnit }}
        </div>
      </td>
      <td class="border-t">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(stockoutdetail.qty_out) }}
        </div>
      </td>
      <td class="border-t">
        <div class="px-6 py-4">
          {{ stockoutdetail.desc }}
        </div>
      </td>
      <td class="py-2 border-t">
        <div v-if="!disabled" class="flex items-center px-6 py-4">
          <button title="Edit Detail" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Detail" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
  </tr>
</template>

<script lang="js">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import { find } from 'lodash'
import NumberInput from '@/Shared/NumberInput'
import TextInput from '@/Shared/TextInput'
import clone from 'lodash/clone'

export default {
    components: {
        Icon,
        NumberInput,
        TextInput,
    },
    props: {
        stockoutdetail: Object,
        items: Object,
        errors: Object,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        perPage: {
            type: Number,
            default: 10,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const detail = ref(props.stockoutdetail)
        const oriData = ref(typeof stockoutdetail)

        return {
            detail,
            oriData,
        }
    },
    computed: {
        selectedItemUnit () {
            return this.detail.item.id ? find(this.items, ['id', this.detail.item.id]).unit: 'N/A'
        },
        rowNumber () {
            return (this.currentPage > 1) ? ((this.currentPage-1)*this.perPage)+this.rowIndex  : this.rowIndex
        },
    },
    methods: {
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        setSelectedItem (item) {
            this.detail.item = item
        },
        edit () {
            this.oriData = clone(this.stockoutdetail)
            this.detail.item_unit.id = find(this.items, ['id', this.detail.item.id]).unit_id
            this.$emit('edit:detail', this.detail)
        },
        cancel () {
            this.detail = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            this.detail.item_unit.id = find(this.items, ['id', this.detail.item.id]).unit_id
            this.$emit('save', this.detail)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this details?')) {
                this.$emit('destroy:detail', this.stockoutdetail.id)
            }
        },
    },
}
</script>

<style scoped>
.v-select {
    --vs-line-height: 1.9;
}
</style>
